import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'duration',
})
export class DurationPipe implements PipeTransform {
  transform(
    seconds: number,
    output: 'seconds' | 'minutes' | 'hours' | 'adaptative' = 'adaptative',
  ): string {
    switch (output) {
      case 'seconds':
        return `${seconds} sec`;
      case 'minutes':
        return `${Math.floor(seconds / 60)} min`;
      case 'hours':
        return `${Math.floor(seconds / 3600)} h`;
      case 'adaptative':
        const h: number = Math.floor(seconds / 3600);
        const m: number = Math.floor((seconds % 3600) / 60);
        const s: number = seconds % 60;
        let result = '';
        if (h > 0) {
          result += `${h} h `;
        }
        if (m > 0 || h > 0) {
          result += `${m} min `;
        }
        result += `${s} s`;
        return result.trim();
    }
  }
}
